export default __webpack_public_path__ + "static/media/pinboardLogo.277cae3d.svg";